import React from 'react'
import { useNavigate } from 'react-router-dom'
import CivilWorkCard from './CivilWorkCard'
import { Bar, Pie } from 'react-chartjs-2'
import { Pieoptions, WorkAssign } from '../../../../../Helper/Data'

export default function CivilWorkCardManage(props) {

    const { Countdata, HeaderMonthID, HeaderFinancialYear, MonthValue, YearValue, YearLabel, MonthLabel, WardValue, WardLabel, ProjectTypeId, DashboardName } = props
    const navigate = useNavigate()

    const CivilWorkCardNavigate = (name, screenFlag) => {
        navigate(`/WorkAssignedDMCTable?name=${name}&ApiFlag=JR&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)

        // if (name === "Pending") {
        //     navigate(`/gardenworkpending?name=${name}&ApiFlag=Pending&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        // } 
        // else if (name === "Completed") {
        //     navigate(`/gardenworkpending?name=${name}&ApiFlag=Completed&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        // }
    }

    const Targetdata = {
        labels: ['Junior Engineer '],
        datasets: [
            {
                // label: "Pending",
                fill: true,
                backgroundColor: [
                    "#cc2836",
                ],
                height: [
                    "10em"
                ],
                data: [
                    Countdata && Countdata?.UploadAssignWork_Jr_TotalCount,
                    // 0
                ]
            },
            // {
            //     label: "Completed",
            //     fill: true,
            //     backgroundColor: [
            //         "#FFB300",
            //         "#FFB300",
            //         "#FFB300",
            //         "#FFB300"
            //     ],
            //     data: [5, 1, 2, 2]
            // },
            // {
            //     label: "Reopen Pending",
            //     fill: true,
            //     backgroundColor: [
            //         "#253150",
            //         "#253150",
            //         "#253150",
            //         "#253150"
            //     ],
            //     data: [4, 5, 6, 3]
            // }

        ],
    };

    return (
        <div className='row m-1 p-0  bg-white' style={{ border: '1px solid #0d467ee6', borderRadius: '8px ' }}>
            <h5 className=" py-2 mb-0 border5">Civil Work Assign By Officials</h5>

            <div className="col-12 col-lg-7 pt-3 p-0">
                <div className="row pb-3 pb-lg-0 ps-lg-3" >

                    <div className="col-12 col-md-6 col-lg-6 " >
                        <CivilWorkCard
                            title="Junior Engineer"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/civilengineers.png'
                            count={Countdata.UploadAssignWork_Jr_TotalCount ? Countdata.UploadAssignWork_Jr_TotalCount : '0'}
                            // count='0'
                            // navLink='/gardenworkpending'
                            CivilWorkCardNavigate={CivilWorkCardNavigate}
                        />
                    </div>
                    {/* <div className="col-12 col-md-6 col-lg-6 mb-2">
                    <GardenDailyWorkCard
                        title="Completed"
                        cardName='py-2 wwork_img cursor'
                        imgPath='./assets/img/completed1.png'
                        count={Countdata.PreventiveCompletedTotalCount ? Countdata.PreventiveCompletedTotalCount : '0'}
                        // navLink='/gardenworkcomplete'
                        DailyPreventiveWorkNavigate={DailyPreventiveWorkNavigate}
                    />
                </div> */}
                </div>
            </div>
            <div className="col-12 col-lg-5 pt-lg-3">
                {/* <div className="row ">
                    <div className="col-12 ">
                        <div className=" px-3 pb-0 upload_chart bg-white ">
                            <div className="row d-flex justify-content-center align-items-center "> */}

                {
                    (Countdata?.UploadAssignWork_Jr_TotalCount != 0) ?
                        <Bar
                            height={80}
                            // width={100}
                            options={WorkAssign}
                            data={Targetdata}
                        />
                        :
                        <div className='text-danger text-center pt-lg-5 fw-bolder'>
                            No Data Found
                        </div>
                }
                {/* </div>
                        </div>
                    </div>
                </div> */}
            </div>
        </div>

    )

}

